import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "제품소개", href: "#products" },
    { label: "회사소개", href: "#about" },
    { label: "시공실적", href: "#achievements" },
    { label: "연락처", href: "#contact" },
  ];

  const handleAnchorClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-black text-lg">SC</span>
          </div>
          <div className="flex flex-col">
            <span className={`font-black text-lg leading-tight ${scrolled ? "text-gray-900" : "text-white"}`}>
              삼성콘크리트(주)
            </span>
            <span className={`text-xs leading-tight ${scrolled ? "text-orange-500" : "text-orange-300"}`}>
              SAMSUNG CONCRETE
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleAnchorClick(link.href)}
              className={`text-sm font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-700 hover:text-orange-500" : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleAnchorClick("#contact")}
            className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold px-6 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            견적문의
          </button>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className={`lg:hidden cursor-pointer ${scrolled ? "text-gray-900" : "text-white"}`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="flex flex-col px-6 py-4 gap-4">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleAnchorClick(link.href)}
                className="text-gray-700 font-semibold text-sm text-left cursor-pointer hover:text-orange-500 transition-colors whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleAnchorClick("#contact")}
              className="bg-orange-500 text-white text-sm font-bold px-6 py-2.5 rounded-full w-fit cursor-pointer whitespace-nowrap"
            >
              견적문의
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
